export default __webpack_public_path__ + "static/media/flourish.b788b2b5.png";